module.exports = __webpack_public_path__ + "assets/img/free_29.23384afb.png";